<template>
<div>
  <div class=" container-fluid   ">
        <div class="llp-container-section  heightcontainer ">
 <top-header id="height2"></top-header>
      <main-menu id="height3"></main-menu>

<div v-if="popUpType=='viewDealerName'">
      <div class=" container-fluid menu-margin-top"  >
      <div class="modal-backdrop">
        <div class="card col-lg-10 col-md-8 mt-md-4 col-11 p-0">

            <div class="postmodalcontent" >
                <div class="modal-header borderbottom p-4">

                    <button type="button" class="close" @click="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                 <div class="modal-body bodymodal11">
                   <center> <p>Recommended Value For DealerName Is <b>{{dealerNameData}}</b></p></center>
                    <br><br>
                    <center>
    <button type="submit" class="btn btn-secondary" @click="addDealerName">Accept</button>

 </center>

      </div></div> </div></div></div></div>

    <!-- Start the code for this screen here -->
<div id="dealer" class=" container-fluid overflow-auto pb-4 menu-margin-top" style="padding-left:0px;padding-right:0px">
    	<div>
    <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b>Create Dealer Account</b></span></nav>
     <div v-if="saved">
       <p align ="center" class="confirm-message"> {{message}} </p>
     </div>
     <div v-if="failure">
       <p align ="center" class="alert-danger"> {{failureMessage}} </p>
     </div>
      <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  row-cols-2 p-2 ">
         <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <label for="dealerName" class="col-form-label col-form-label-sm required" > Dealer Name </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <input type="text" data-vv-as="Dealer Name"  @focusout="getDealerNameList()" v-validate="'required'" name="DName" v-model.trim="dealer.dealerName"  class="form-control input-sm" autofocus placeholder="Enter Dealer Name" :maxlength="100"  >
          <div v-if="errors.has('DName')" class="alert-danger" > {{ errors.first('DName') }} </div>
        </div>
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center ">
        <label for="line1" class="col-form-label col-form-label-sm "> Contact Title </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <input type="text"  v-model.trim="dealer.contactTitle" class="form-control input-sm" placeholder="Enter Contact Title" :maxlength="50" >
        </div>
      </div>
      <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  row-cols-2 p-2 ">
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <label for="line1" class="col-form-label col-form-label-sm"> Primary Contact First Name </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <input type="text"  v-model.trim="dealer.firstName" class="form-control input-sm" placeholder="Enter First Name" :maxlength="50" >
        </div>
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <label for="line2" class="col-form-label col-form-label-sm"> Primary Contact Middle Name </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <input type="text"    v-model.trim="dealer.middleName" class="form-control input-sm" placeholder="Enter Middle Name" :maxlength="50" >
        </div>
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <label for="city" class="col-form-label col-form-label-sm"> Primary Contact Last Name </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <input type="text"  v-model.trim="dealer.lastName" class="form-control input-sm" placeholder="Enter Last Name" :maxlength="50" >
        </div>
      </div>
      <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  row-cols-2 p-2 ">
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <label for="line1" class="col-form-label col-form-label-sm"> Address Line1 </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <input type="text" data-vv-as="Address Line1"   name="Line1" v-model.trim="dealer.addressLine1" class="form-control input-sm" placeholder="Enter Address Line1" :maxlength="50" >
        <div v-if="errors.has('Line1')" class="alert-danger" > {{ errors.first('Line1') }} </div>
        </div>
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <label for="line2" class="col-form-label col-form-label-sm"> Address Line2 </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <input type="text"   name="Address Line2" v-model.trim="dealer.addressLine2" class="form-control input-sm" placeholder="Enter Address Line2" :maxlength="50" >
        </div>
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <label for="city" class="col-form-label col-form-label-sm"> City </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <input type="text"   name="City"  data-vv-as="City"  v-model.trim="dealer.city" class="form-control input-sm" placeholder="Enter City" :maxlength="50" >
        <div v-if="errors.has('City')" class="alert-danger" > {{ errors.first('City') }} </div>
        </div>
      </div>
      <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  row-cols-2 p-2 ">
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <label for="state" class="col-form-label col-form-label-sm" > State </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <select name="State" v-model.trim="dealer.stateCode" class="form-control input-sm" data-vv-as="State">
          <option disabled value=""> Select a State </option>
             <option v-for="state in states" v-bind:value="state.stateFipsC" v-bind:key="state.stateFipsC">{{state.stateN}} </option>
        </select>
        <div v-if="errors.has('State')" class="alert-danger" > {{ errors.first('State') }} </div>
        </div>
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <label for="country" class="col-form-label col-form-label-sm" > Country </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
          <input type="text" name="Country" v-model.trim="dealer.country" class="form-control input-sm" disabled>
        </div>
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <label for="zip" class="col-form-label col-form-label-sm"> Zip Code </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <input type="text" name="Zip" data-vv-as="Zip Code" v-validate="{  regex: /^(\d)(?!\1+$)/, digits:5 }" v-model.trim="dealer.zipcode"  @input="zipDecoder" class="form-control input-sm" placeholder="Enter 5 Digit zip" :maxlength="5" >
        <div v-if="errors.has('Zip')" class="alert-danger" > {{ errors.first('Zip') }} </div>
        </div>
      </div>
       <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  row-cols-2 p-2 ">
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <label for="workNumber" class="col-form-label col-form-label-sm"> Office Number </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <input type="text"  name="Office Number" class="form-control input-sm" @input="formatPhoneNumber" @blur="formatPhoneNumber" v-model.trim="dealer.officeNum" v-validate="'min:10|max:14'" data-vv-as="Office Number" placeholder="Enter Office Number" :maxlength="10" >
        <div v-if="errors.has('Office Number')" class="alert-danger" > {{ errors.first('Office Number') }} </div>
        </div>
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <label for="email" class="col-form-label col-form-label-sm"> Email </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <input type="text" name="Email"  v-validate="'email'" data-vv-as="Email" v-model.trim="dealer.email"  class="form-control input-sm" placeholder="Enter Email" :maxlength="50" >
        <div v-if="errors.has('Email')" class="alert-danger" > {{ errors.first('Email') }} </div>
        </div>
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <label for="contactmethod" class="col-form-label col-form-label-sm" > Contact </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <select name="contact" v-model.trim="dealer.preferredContact" disabled class="form-control input-sm" >
          <option v-for="contact in preferredContactOptions" v-bind:value="contact.value" v-bind:key="contact.value">{{contact.text}}  </option>
        </select>
        </div>
      </div>
      <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  row-cols-2 p-2 ">
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <label for="status" class="col-form-label col-form-label-sm"> Dealer Status </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <select name="status" v-model.trim="dealer.status" data-vv-as="Status" class="form-control input-sm">
          <option v-for="dstatus in dealerStatusOptions" v-bind:value="dstatus.value" v-bind:key="dstatus.value">{{dstatus.text}} </option>
        </select>
        <div v-if="errors.has('Status')" class="alert-danger" > {{ errors.first('Status') }} </div>
        </div>
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <label for="priority" class="col-form-label col-form-label-sm"> Priority </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <select name="Priority" v-model.trim="dealer.priority" data-vv-as="Priority" class="form-control input-sm" disabled >
          <option disabled value=""> Select Priority </option>
          <option v-for="priority in priortyList" v-bind:key="priority.key">{{priority.value}} </option>
        </select>
        <div v-if="errors.has('Priority')"  > {{ errors.first('Priority') }} </div>
        </div>
         <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <label class="col-form-label col-form-label-sm"> Salesperson </label>
        </div>
         <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
         <select  v-model.trim="dealer.salesAgentId"  v-if="this.disableemployeedd" class="form-control input-sm"  disabled>
          <option  disabled value=""> Select a Salesperson </option>
             <option v-for="(option,index) in agentList" v-bind:value="option.employeeId" v-bind:key="index"> {{ option.firstName }} {{ option.middleName.length !=0 ?  ',' +option.middleName : ''}} , {{ option.lastName }} </option>
        </select>
         <select  v-else v-model.trim="dealer.salesAgentId" class="form-control input-sm">
          <option  disabled value=""> Select a Salesperson </option>
             <option v-for="(option,index) in agentList" v-bind:value="option.employeeId" v-bind:key="index"> {{ option.firstName }} {{ option.middleName.length !=0 ?  ',' +option.middleName : ''}} , {{ option.lastName }} </option>
        </select>
        </div>
      </div>

       <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  row-cols-2 p-2 ">
       <div class="col-12 col-md-12 d-flex justify-content-lg-end">
        <label for="priority" class="col-form-label col-form-label-sm"> App Source </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <select name="AppSource" v-model.trim="dealer.appSource" data-vv-as="AppSource" class="form-control input-sm">
          <option disabled value=""> Select an App Source </option>
          <option v-for="appSource in appSourceList" v-bind:key="appSource.key">{{appSource.value}} </option>
        </select>
        </div>
        <div class="col-12 col-md-12 d-flex justify-content-lg-end">
        <label for="priority" class="col-form-label col-form-label-sm"> Fraud Indicator </label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
        <select  name="fraudIndicator" placeholder="Select fraudIndicator" v-model.trim="dealer.fraudIndicator" data-vv-as="indicator" class="form-control input-sm">
          <option v-for="indicator in fraudIndicatorList" v-bind:key="indicator.key">{{indicator.keyValue}} </option>
        </select>
        </div>
        <div class="col-12 col-md-12 d-flex justify-content-lg-end" v-if="dealer.fraudIndicator == 'Y' || dealer.fraudCell == 'Y'">
        <label for="priority" class="col-form-label col-form-label-sm" >Red Flag Reason</label>
        </div>
        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 " v-if="dealer.fraudIndicator == 'Y' || dealer.fraudCell == 'Y'">
       <select v-model.trim="dealer.redFlagReason" class="form-control input-sm">
               <option disabled value="">Select Redflag Reason</option>
            <option
              v-for="(indicator,index) in redFlagReasonList"
              v-bind:key="index"
            >{{indicator.keyValue}}</option>
          </select>
        </div>

       </div>

       <br>
       <div v-if="this.secondaryContactList.length>1 ||this.addSecondaryContact== true ">
        <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b>Secondary Contacts</b></span></nav>
        <div class="table-responsive table-responsive-sm">
              <table id="dealerstable"   class="table table-sm table-bordered table-striped ">
                <thead>
                   <tr class="table-month-header-blue">
                          <th v-for="(dach,index) in secondarycontactscolnames"  :key="index">
                            {{ dach.header }}
                          </th>
                    </tr>
                </thead>

                    <tr v-if="this.addSecondaryContact== true">
                            <td >
                                  <input type="text" data-vv-scope="addscontact" class="form-control input-sm"  v-validate="'required'" name="First Name" data-vv-as="First Name" placeholder="Enter First Name" :maxlength="50" v-model="secondaryContactList.secondaryContactFirstName">
                                  <div v-if="errors.has('addscontact.First Name')" class="alert-danger" >
                                        {{ errors.first('addscontact.First Name') }}
                                  </div>
                            </td>
                            <td >
                                  <input type="text" placeholder="Enter Middle Name" class="form-control input-sm"  :maxlength="50" v-model="secondaryContactList.secondaryContactMiddleName">
                            </td>
                            <td >
                                  <input type="text" name="Last Name" data-vv-as="Last Name" class="form-control input-sm" placeholder="Enter Last Name" :maxlength="50" v-model="secondaryContactList.secondaryContactLastName">
                                  <div v-if="errors.has('Last Name')" class="alert-danger" >
                                        {{ errors.first('Last Name') }}
                                  </div>
                            </td>
                            <td >
                                  <input type="text" data-vv-scope="addscontact" name='Contact Title' class="form-control input-sm"  data-vv-as="Contact Title" placeholder="Enter Contact Title" :maxlength="50" v-model="secondaryContactList.contactTitle">
                                  <div v-if="errors.has('addscontact.Contact Title')" class="alert-danger" >
                                       {{ errors.first('addscontact.Contact Title') }}
                                  </div>
                            </td>
                            <td >
                                  <input type="text"  data-vv-scope="addscontact" name="Work Number" class="form-control input-sm"  @input="formatWorkNumber" @blur="formatWorkNumber" v-model.trim="secondaryContactList.secondaryContactWorkNumber" maxlength="10" v-validate="'min:10|max:14'" data-vv-as="Work Number" placeholder="Enter Work Number">
                                  <div v-if="errors.has('addscontact.Work Number')" class="alert-danger" >
                                        {{ errors.first('addscontact.Work Number') }}
                                  </div>
                            </td>
                            <td >
                                  <input type="text"  v-model.trim="secondaryContactList.secondaryContactMobileNumber" class="form-control input-sm"  data-vv-name="Mobile Number" data-vv-scope="addscontact" data-vv-as="Mobile Number" v-validate="'min:10|max:14'" @input="formatCellPhoneNumber" @blur="formatCellPhoneNumber"  title="Please enter 10 digits" placeholder="Enter Mobile Number" maxlength="10">
                                  <div v-if="errors.has('addscontact.Mobile Number')" class="alert-danger" >
                                        {{ errors.first('addscontact.Mobile Number') }}
                                  </div>
                            </td>
                            <td >
                                  <input id="fnum"  data-vv-scope="addscontact" placeholder="Enter Fax Number" class="form-control input-sm"  title="Please enter 10 digits" v-model.trim="secondaryContactList.secondaryContactFaxNumber" maxlength="10" v-validate="'min:10|max:14'" data-vv-name="Fax" @input="formatFaxNumber" @blur="formatFaxNumber"/>
                                  <div v-if="errors.has('addscontact.Fax')" class="alert-danger" >
                                        {{ errors.first('addscontact.Fax') }}
                                  </div>
                            </td>
                            <td >
                                  <input id="secondaryemail"  data-vv-scope="addscontact" class="form-control input-sm"  placeholder="Enter email" v-model.trim="secondaryContactList.secondaryContactEmail" data-vv-name="Contact Email" data-vv-as="Contact Email" v-validate="'email'" />
                                  <div v-if="errors.has('addscontact.Contact Email')" class="alert-danger"  >
                                        {{ errors.first('addscontact.Contact Email') }}
                                  </div>
                            </td>
                            <td >
                                  <button type="submit" class="btn btn-secondary" @click="addSecondaryContactList">+</button>
                            </td>
                    </tr>
                     <tbody>
                            <tr v-for="(entry,index) of secondaryContactList" :key="index" v-if="index >=1">
                                  <td  >{{entry.secondaryContactFirstName}}</td>
                                <td >{{entry.secondaryContactMiddleName}}</td>
                                <td >{{entry.secondaryContactLastName}}</td>
                                <td >{{entry.contactTitle}}</td>
                                <td >{{entry.secondaryContactWorkNumber}}</td>
                                <td >{{entry.secondaryContactMobileNumber}}</td>
                                <td >{{entry.secondaryContactFaxNumber}}</td>
                                <td >{{entry.secondaryContactEmail}}</td>
                                <td >
                                    <button type="submit"   class="btn btn-secondary"  @click="deleteContact(index)">-</button>
                                </td>
                      </tr>
                </tbody>
            </table>
      </div>

</div>

      <!-- horizontal line break -->
     <div class="horizontal-line mb-3"></div>
    <center class="mb-3">
     <button type="submit" @click="saveDealer"  class="btn btn-secondary" > Save </button>&nbsp;&nbsp;&nbsp;
     <button  class="btn btn-secondary" name="add"  @click="addContact" > Show/Hide Secondary Contact</button>
    </center>
     <br><br>
  </div>
  <!-- End of the code for this screen here -->
</div>
   <bottom-footer></bottom-footer>
    </div>
  </div>
</div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import { store } from '../store.js'
import manageSourceSvc from '../js/http-managesource'
import manageemployeeSvc from '../js/http-employee.js'
import commonservice from '../js/http-common'
import { bus } from '../main'
import { stringify } from 'querystring'
import moment from 'moment'

export default {
  components: { MainMenu,
    TopHeader,
    BottomFooter
  },
  name: 'adddealer',
  data () {
    return {

      popUpType: '',
      dealerNameData: '',
      dealerNameCancel: 'true',
      disableemployeedd: 'false',
      states: [], // gets data from service
      preferredContactOptions: [], // gets data from service
      hello: 'N',
      priortyList: [
        { key: '1', value: '1' },
        { key: '2', value: '2' },
        { key: '3', value: '3' },
        { key: '4', value: '4' },
        { key: '5', value: '5' }
      ],
      appSourceList: [
        { key: '1', value: 'Dealer Track' },
        { key: '2', value: 'Route One' },
        { key: '3', value: 'Other' }
      ],
      dealerStatusOptions: [],
      dealer: this.initializedata(), // intialize dealer entry fields
      agentList: [],
      redFlagReasonList: [],
      saved: false,
      message: '',
      failure: false,
      failureMessage: "We're unable to save dealer information",
      savedDealerId: '',
      region: '',
      secondaryContactList: [{
        secondaryContactFirstName: '',
        secondaryContactMiddleName: '',
        secondaryContactLastName: '',
        contactTitle: '',
        secondaryContactWorkNumber: '',
        secondaryContactMobileNumber: '',
        secondaryContactFaxNumber: '',
        secondaryContactEmail: ''
      }],
      secondarycontactscolnames: [
        { header: 'First Name *' },
        { header: 'Middle Name' },
        { header: 'Last Name' },
        { header: 'Contact Title' },
        { header: 'Work Number' },
        { header: 'Mobile Number' },
        { header: 'Fax Number' },
        { header: 'Email' },
        { header: 'Action' }
      ],
      addSecondaryContact: false
    }
  },
  methods: {

    addDealerName () {
      this.dealer.dealerName = this.dealer.dealerName.split(/\s+/).join(' ')
      this.close()
      this.existingDealerNameCheck(this.dealer.dealerName.split(/\s+/).join(' '))
    },
    getDealerNameList () {
      this.existingDealerNameCheck()
      var str = this.dealer.dealerName

      if (str.indexOf('  ') >= 0) {
        this.popUpType = 'viewDealerName'
        this.dealerNameData = this.dealer.dealerName.split(/\s+/).join(' ')
      }
    },

    zipDecoder () {
      if (this.dealer.zipcode.length == 5) {
        commonservice.get('/statefip/zipCode/' + this.dealer.zipcode)
          .then(response => {
            if (response.data.city != null) {
              this.dealer.city = response.data.city
            } else {
              this.dealer.city = ''
            }
            if (response.data.city != null) {
              this.getDealerStateDetails(response.data.state)
            } else {
              this.dealer.stateCode = ''
            }
          })

          .catch(e => { this.errorslist.push(e) })
      }
    },
    getDealerStateDetails (stateFipsC) {
      for (let i = 0; i < this.states.length; i++) {
        if (this.states[i].stateAlphaC == stateFipsC) {
          // this.customer.selectedStateCode = this.states[i];
          this.dealer.stateCode = this.states[i].stateFipsC
        }
      }
    },
    // use console only during developmet
    formatPhoneNumber: function (event) {
      var phone = this.dealer.officeNum
      phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.dealer.officeNum = phone
    },
    formatCellPhoneNumber: function (event) {
      var phone = this.secondaryContactList.secondaryContactMobileNumber
      phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.secondaryContactList.secondaryContactMobileNumber = phone
    },
    formatWorkNumber: function (event) {
      var phone = this.secondaryContactList.secondaryContactWorkNumber
      phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.secondaryContactList.secondaryContactWorkNumber = phone
    },
    formatFaxNumber: function (event) {
      var phone = this.secondaryContactList.secondaryContactFaxNumber
      phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.secondaryContactList.secondaryContactFaxNumber = phone
    },

    /* eslint-disable no-console */
    fetchData () {
      commonservice.get('/statefip/').then(response => {
        this.states = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
      commonservice.get('/staticdata/preferredcontact/').then(response => {
        this.preferredContactOptions = response.data
      })
        .catch(e => { this.errors.push(e) })

      commonservice.get('/staticdata/status/').then(response => {
        this.dealerStatusOptions = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
      this.retrieveAgentList()
    },
    dealerFraud () {
      if (this.dealer.fraudIndicator == 'N') { this.dealer.redFlagReason = '' }
    },
    retrieveAgentList () {
      if (this.$session.get('user_role') == 'SR') {
        this.agentList = [
          { 'employeeId': this.$session.get('employee_id'),
            'firstName': this.$session.get('first_name'),
            'lastName': this.$session.get('last_name'),
            'middleName': this.$session.get('middle_name')
          }
        ]
        this.dealer.salesAgentId = this.$session.get('employee_id')
        this.disableemployeedd = true
      } else {
        this.disableemployeedd = false
        let searchEmployee = {
          'firstName': '',
          'lastName': '',
          'roleType': 'SR',
          'statusCode': 'A'
        }
        manageemployeeSvc.post('/employee/search/', searchEmployee).then(response => {
          this.agentList = response.data
        })
          .catch(e => {
            console.log('Failed to load salesperson:' + e)
          })
      }
    },
    existingDealerNameCheck () {
      manageSourceSvc
        .post('/existingDealerNameCheck/' + this.dealer.dealerName.split(/\s+/).join(' '))
        .then(response => {
          // console.log("Resonse JSON:"+JSON.stringify(response));
          var status = response.data
          if (status == 'CONFLICT' && this.popUpType != 'viewDealerName') {
            this.failure = true
            this.failureMessage = 'Dealer Name Already exists'
            this.dealer.dealerName = this.dealer.dealerName.split(/\s+/).join(' ')

            setTimeout(() => {
              this.failureMessage = ''
            }, 3000)
          }
        })
    },
    saveDealer () {
      if (this.popUpType != 'viewDealerName') {
        // Reset any data
        this.failure = false
        var currentDate = new Date()
        this.message = ''
        this.addSecondaryContact = false
        // this.failureMessage = '';
        // check the validations and proceed only if everything good
        this.$validator.validateAll().then(() => {
          if (!this.errors.any()) {
            let addDealerPayload = {
              'dealerName': this.dealer.dealerName,
              'firstName': this.dealer.firstName.length == 0 ? null : this.dealer.firstName,
              'middleName': this.dealer.middleName.length == 0 ? null : this.dealer.middleName,
              'lastName': this.dealer.lastName.length == 0 ? null : this.dealer.lastName,
              'contactTitle': this.dealer.contactTitle.length == 0 ? null : this.dealer.contactTitle,
              'fraudInd': this.dealer.fraudIndicator,
              'redFlagReason': this.dealer.redFlagReason,
              'address': {
                'street1': this.dealer.addressLine1,
                'street2': this.dealer.addressLine2,
                'city': this.dealer.city,
                'zipCode': this.dealer.zipcode,
                'stateFipsC': this.dealer.stateCode.length == 0 ? null : this.dealer.stateCode,
                'country': this.dealer.country,
                'addressType': null, // TODO- Set as Mailing
                'inactiveD': null,
                // "creationD": currentDate,
                'creationUserI': this.$session.get('user_id'),
                'lastUpdatedD': null,
                'lastUpdatedUserI': null
              },
              'digitalContactInfo': {
                // "faxNumber": this.dealer.fax,
                'preferredContact': this.dealer.preferredContact,
                'workNumber': this.dealer.officeNum.replace(/[^0-9]/g, ''),
                'email': this.dealer.email
              },
              'appSource': this.dealer.appSource.length == 0 ? null : this.dealer.appSource,
              'priority': this.dealer.priority,
              'dealerStatue': this.dealer.status,
              'dealerSecondaryContacts': this.constructSecondayContacts(currentDate),
              // "inactiveD":inactivedate,
              // "creationD": currentDate,
              'creationUserI': this.$session.get('user_id'),
              'lastUpdatedD': null,
              'lastUpdatedUserI': null
            }

            // console.log(addDealerPayload);
            // Call REST API
            manageSourceSvc
              .post('/dealer', addDealerPayload)
              .then(response => {
                // console.log("Resonse JSON:"+JSON.stringify(response));
                var status = response.data
                if (status == 'CREATED') {
                  // console.log("Dealer saved successfully!!");
                  this.saved = true
                  this.message = 'Dealer has been saved successfully!!!'
                  setTimeout(() => {
                    this.message = ''
                  }, 3000)
                  // Save the Dealer Assignment
                  if (this.dealer.salesAgentId != '') {
                    this.AssignDealerToEmployee()
                  }
                  // reset form
                  this.dealer = this.initializedata()

                  this.secondaryContactList = []
                  this.addSecondaryContact = false
                  this.errors.clear()
                  this.$validator.reset()
                } else if (status == 'BAD_REQUEST') {
                  // console.log("Failed to save Dealer!!");
                  this.failure = true
                } else if (status == 'CONFLICT') {
                  // Dealer already exists
                  this.failure = true
                  this.failureMessage = 'Dealer Name Already exists'
                  setTimeout(() => {
                    this.failureMessage = ''
                  }, 3000)
                } else {
                  // console.log("Failed to save Dealer!!");
                  this.failure = true
                }
              })
              .catch(e => {
                console.log('Failed: ' + e)
                this.failure = true
              })
          }
        })

        /* eslint-disable no-console */
        //  TODO- Any Local variable assign here
      }
    },
    constructSecondayContacts: function (currentDate) {
      var ebcrlist = []
      var currentDate = new Date()
      // console.log("construct")
      for (var i = 1; i < this.secondaryContactList.length; i++) {
        var reviewobject = this.secondaryContactList[i]
        ebcrlist.push({
          'inactiveD': null,
          'creationD': currentDate,
          'creationUserI': this.$session.get('user_id'),
          'lastUpdatedD': null,
          'lastUpdatedUserI': null,
          'dealerId': !this.dealerId ? null : dealerId,
          'firstName': reviewobject.secondaryContactFirstName,
          'middleName': reviewobject.secondaryContactMiddleName,
          'lastName': reviewobject.secondaryContactLastName,
          'contactTitle': reviewobject.contactTitle,
          'workNumber': reviewobject.secondaryContactWorkNumber == null ? null : reviewobject.secondaryContactWorkNumber.replace(/[^0-9]/g, ''),
          'mobileNumber': reviewobject.secondaryContactMobileNumber == null ? null : reviewobject.secondaryContactMobileNumber.replace(/[^0-9]/g, ''),
          'faxNumber': (reviewobject.secondaryContactFaxNumber == null ? null : reviewobject.secondaryContactFaxNumber.replace(/[^0-9]/g, '')),
          'email': reviewobject.secondaryContactEmail

        })
      }
      return ebcrlist
    },
    initializedata () {
      return {
        fraudIndicatorList: [],
        fraudIndicator: 'N',
        redFlagReason: '',
        dealerId: '',
        dealerName: '',
        firstName: '',
        middleName: '',
        lastName: '',
        contactTitle: '',
        addressId: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        stateCode: '',
        country: 'USA',
        zipcode: '',
        digitalContactId: '',
        officeNum: '',
        // fax:'',
        email: 'dealer' + moment(new Date()).format('MMDDYYYYhhmmss') + '@system.com',
        preferredContact: 'A',
        priority: '1', // To make default priority as one
        status: 'A',
        createdDate: '',
        createdUserId: '',
        salesAgentId: '',
        appSource: '',
        secondaryContactList: [],
        addSecondaryContact: false

      }
    },
    close () {
      this.popUpType = false
    },
    AssignDealerToEmployee () {
      // get the newly created dealer
      var state = this.dealer.stateCode
      var empid = this.dealer.salesAgentId
      manageSourceSvc.get('/dealerbyname/' + this.dealer.dealerName)
        .then(response => response.data)
        .then(data => {
          // console.log("DATE AFTER DEALER SAVE: "+ data.dealerId);
          this.savedDealerId = data.dealerId
          commonservice.get('regionstates/state/' + state)
            .then(response => response.data)
            .then(data => {
              // console.log("get region Response2 " + data.id.regionC);
              this.region = data.id.regionC
              var ebcrlist = []
              var currentDate = new Date()
              ebcrlist.push({
                'inactiveD': null,
                'creationD': currentDate,
                'creationUserI': this.$session.get('user_id'),
                // 'lastUpdatedUserI': !this.selectedEmployeeId ? null : this.$session.get('user_id'),
                'id': {
                  'employeeId': empid,
                  'dealerId': this.savedDealerId,
                  'regionC': this.region,
                  'stateFipsC': state
                }
              })
              manageemployeeSvc.post('/empbusinesscoveragearea', ebcrlist).then(response => {

              })
                .catch(e => {
                  console.log('Failed: ' + e)
                  // this.failure = true;
                })
            })
            .catch(e => {
              console.log('ERROR in getting saved Region')
              // this.errors.push(e);
            })
        })
        .catch(e => {
          console.log('ERROR in getting saved Dealer iD')
          // this.errors.push(e);
        })
    },
    addContact () {
      if (this.addSecondaryContact == true) { this.addSecondaryContact = false } else { this.addSecondaryContact = true }
    },
    addSecondaryContactList () {
      var rownum = 0
      for (var i = 0; i < this.secondaryContactList.length; i++) {
        rownum = i + 1
        this.secondaryContactList[i].rownumber = rownum
      }
      // console.log("This is")

      this.$validator.validateAll('addscontact').then((isValid) => {
        if (isValid) {
          this.secondaryContactList.push({
            'rownumber': rownum + 1,
            'secondaryContactFirstName': this.secondaryContactList.secondaryContactFirstName,
            'secondaryContactMiddleName': this.secondaryContactList.secondaryContactMiddleName,
            'secondaryContactLastName': this.secondaryContactList.secondaryContactLastName,
            'contactTitle': this.secondaryContactList.contactTitle,
            'secondaryContactWorkNumber': this.secondaryContactList.secondaryContactWorkNumber,
            'secondaryContactMobileNumber': this.secondaryContactList.secondaryContactMobileNumber,
            'secondaryContactFaxNumber': this.secondaryContactList.secondaryContactFaxNumber,
            'secondaryContactEmail': this.secondaryContactList.secondaryContactEmail
          })
          this.secondaryContactList.secondaryContactFirstName = ''
          this.secondaryContactList.secondaryContactMiddleName = ''
          this.secondaryContactList.secondaryContactLastName = '',
          this.secondaryContactList.secondaryContactFaxNumber = '',
          this.secondaryContactList.secondaryContactEmail = '',
          this.secondaryContactList.contactTitle = '',
          this.secondaryContactList.secondaryContactMobileNumber = '',
          this.secondaryContactList.secondaryContactWorkNumber = ''
          this.addSecondaryContact = true
        }
      })
    },
    // deleteSecondaryContact: function( firstName,lastName,email)
    // {
    //     var contactlist=[];
    //     this.addSecondaryContact= false
    //     for(var i=0;i<this.secondaryContactList.length;i++)
    //     {
    //       var contactobject = this.secondaryContactList[i];
    //       if(contactobject.secondaryContactEmail != email)
    //       {
    //         contactlist.push(contactobject)
    //       }
    //     }
    //     this.secondaryContactList =[];
    //     this.secondaryContactList = contactlist
    // },
    deleteContact: function (index) {
      this.secondaryContactList.splice(index, 1)
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#dealer').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.myFunction()
    this.menuheight()
    commonservice.get('/keyvalues/getkeyvalues/' + 1).then(response => { this.fraudIndicatorList = response.data }).catch(e => { this.errorslist.push(e) })
    commonservice
      .get('/keyvalues/getkeyvalues/' + 23)
      .then(response => {
        this.redFlagReasonList = response.data
      })
      .catch(e => {
        this.errorslist.push(e)
      })
    this.fetchData()
  }
}
</script>
<style scoped>
.card {
    padding: -5px !important;
    margin: 0 auto;
}
.postmodalcontent{
  border: none !important;
}
.modal-backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000 !important;
}

.button-cancel11 {
  border: 1px solid #1f1f1f;
  border-radius: 4px;
  transition : ease-out 0.3s;
  font-size: 14px !important;
	position: relative;
	z-index : 1;
}
.modal-header{
  border: none;
}
.bodymodal11{
  padding: 0 !important;
  height:20vh;
  overflow-y: auto;

}
.bodymodal11{
  background-color: white;
}
.profile-border{
  padding: 2px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
.close{
  padding: 1px 7px 5px 7px !important;
  margin-top: -3px !important;
  margin-right: 5px !important;
}
.close:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.loadingBgImg{
  background: transparent url('../assets/logout.png') center no-repeat;
  background-size: 30px 30px;
}
@media screen and  (max-width : 600px){
  .card{
    margin-top: 4%;
  }
}
.nav-link {
    display: block;
    padding: 0.5rem 1rem;
    background-color: #17a2b8;
    color: black;
    margin-left: 5px;
}
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color: black;
    background-color: white;
    border-color: #A9A9A9;
    border-bottom: none;
}

.sidebyside {
  float: right;
}
</style>
